import React, { useEffect, useState } from 'react';
import { Modal, Button, Tab, Tabs, Form } from 'react-bootstrap';
import Select from 'react-select';
import { loadListNameDropdown } from '../redux/action';
import * as HeaderAuthentication from '../../components/HeaderAuthentication'
import { useSelector } from 'react-redux';
import { loadCreateListAi } from '../redux/ai_connect/ai_action';
import { useNavigate } from 'react-router-dom';

const AddToListModal = ({ show, onHide, selectedContacts, setSelectedRowsData, setSelectedRowIds, signInDetails,
    dispatch, paginatedRows, searchContactData, setIsSelectAll }) => {
    const navigate = useNavigate();
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;

    const { getListName } = useSelector((state) => state.data);

    const [tabKey, setTabKey] = useState('create');
    const [newListName, setNewListName] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [error, setError] = useState('');
    const [listStatus, setListStatus] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [createdListName, setCreatedListName] = useState("");

    const handleCreateNewList = (tabKey) => {

        let listName = ''
        if (tabKey === 'create' && newListName.trim() === '') {
            setError('Please enter a list name.');
            return;
        } else if (tabKey === 'add' && !selectedOption) {
            setError('Please select a list.');
            return;
        }
        setListStatus(true)

        if (tabKey === 'create') {
            listName = newListName.trim()
        } else if (tabKey === "add") {
            listName = selectedOption?.label
        }


        const selectedRows = selectedContacts;

        console.log(selectedRows, "selectedRows")

        const providerFromRows = selectedRows
            .map((row) => row.provider)
            .find((p) => p && String(p).trim() !== "");

        const providerName = (
            providerFromRows ||
            sessionStorage.getItem("last_provider_used") ||
            "salestarget"
        ).toLowerCase();

        if (selectedRows.length === 0) {
            alert("No valid contacts found in selected rows.");
            setListStatus(false);
            return;
        }

        const contacts = selectedRows
            .map((row) => {
                const id = parseInt(row.apiId);
                return isNaN(id) ? null : { contact_id: id };
            })
            .filter((c) => c !== null);

        if (contacts.length === 0) {
            alert('No valid contacts found in selected rows.');
            return;
        }


        const requestPayload = {
            user_id: parseInt(signInDetails?.[0]?.id),
            user_name: signInDetails?.[0]?.name,
            sbn_id: signInDetails?.[0]?.sbn_id,
            list_name: listName,
            contacts: selectedRows,
            provider: providerName,

        };
        console.log(requestPayload, "requestPayload")

        const requestOption = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };

        dispatch(loadCreateListAi(requestOption, onHide, setListStatus)).then(
            (resp) => {
                // const apiResponses = JSON.parse(resp);
                console.log(resp, "apiResponses")
                if (resp.success_code === 100) {
                    setSelectedRowsData([])
                    setSelectedRowIds({
                        type: 'include',
                        ids: new Set(),
                    })
                    setIsSelectAll(false);
                    setIsSuccess(true);
                    setCreatedListName(
                        tabKey === "create"
                            ? newListName
                            : selectedOption?.label
                    );

                    // onHide()
                }
            }
        ).catch((err) => {
            setListStatus(false)
            if (err.name === "AbortError") {
                console.log("Previous request aborted ✅");
            } else {
                console.log(err);
            }
        });

        // console.log(requestPayload, 'requestPayload')
    }

    const handleAction = () => {
        if (tabKey === 'create') {
            handleCreateNewList(tabKey);
        } else {
            handleCreateNewList(tabKey);
        }
    };

    useEffect(() => {
        if (tabKey === 'add' && signInID && sbnID) {
            dispatch(loadListNameDropdown(signInID, sbnID));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabKey, signInID, sbnID]);

    // region navigate to list page after list create
    const navigateToList = () => {
        onHide();
        setIsSuccess(false);
        navigate('/my-list')
    }
    // endregion

    const closeModal = () => {
        setError("")
        onHide();
        setIsSuccess(false);
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="md"
            className="add-to-list-modal"
        >
            {!isSuccess && <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-list-ul me-2"></i>
                    Add to List - <div className="selected-count-card">
                        <span className="count-label">
                            Selected Contacts:
                        </span>

                        <span className="count-badge">
                            {selectedContacts?.length || 0}
                        </span>
                    </div>
                </Modal.Title>
            </Modal.Header>}

            <Modal.Body>

                {!isSuccess ? (
                    <>


                        <Tabs
                            activeKey={tabKey}
                            onSelect={(k) => {
                                setTabKey(k);
                                setError("");
                            }}
                            className="custom-tabs"
                        >
                            {/* CREATE TAB */}
                            <Tab eventKey="create" title={
                                <>
                                    <i className="fa fa-plus-circle me-2"></i>
                                    Create New
                                </>
                            }>
                                <div className="tab-content-card">
                                    <Form.Group>
                                        <Form.Label>List Name</Form.Label>

                                        <Form.Control
                                            type="text"
                                            placeholder="Enter list name"
                                            value={newListName}
                                            onChange={(e) => {
                                                setNewListName(e.target.value);
                                                setError("");
                                            }}
                                        />

                                        {error && (
                                            <div className="text-danger mt-2">{error}</div>
                                        )}
                                    </Form.Group>
                                </div>
                            </Tab>

                            {/* EXISTING TAB */}
                            <Tab eventKey="add" title={
                                <>
                                    <i className="fa fa-folder-open me-2"></i>
                                    Existing List
                                </>
                            }>
                                <div className="tab-content-card">
                                    <Form.Group>
                                        <Form.Label>Select List</Form.Label>

                                        {/* <Select
                                            options={getListName}
                                            value={selectedOption}
                                            onChange={(selected) => {
                                                setSelectedOption(selected);
                                                setError("");
                                            }}
                                            placeholder="Choose a list..."
                                        /> */}
                                        <Select
                                            options={getListName}
                                            value={selectedOption}
                                            onChange={(selected) => {
                                                setSelectedOption(selected);
                                                setError("");
                                            }}
                                            placeholder="Choose a list..."
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),

                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),

                                                menuList: (base) => ({
                                                    ...base,
                                                    maxHeight: "250px",
                                                    overflowY: "auto",
                                                }),
                                            }}
                                        />

                                        {error && (
                                            <div className="text-danger mt-2">{error}</div>
                                        )}
                                    </Form.Group>
                                </div>
                            </Tab>
                        </Tabs>
                    </>
                ) : (
                    /* ✅ SUCCESS SCREEN */
                    <div className="text-center py-4">

                        <div style={{ fontSize: "40px", color: "green" }}>
                            <i className="fa fa-check-circle" style={{ fontSize: "40px" }}></i>
                        </div>

                        <h4 className="mt-3">
                            List Updated Successfully 🎉
                        </h4>

                        <p className="text-muted">
                            <b>"{createdListName}"</b> is ready. You can now view it.
                        </p>

                        <div className='list-succes-btns'>
                            <Button
                                variant="primary"
                                className=""
                                onClick={navigateToList}
                            >
                                <i className="fa fa-eye me-2"></i>
                                View List
                            </Button>
                            <Button
                                variant="light"
                                onClick={closeModal}
                                className="cancel-btn"
                            >
                                Close
                            </Button>

                        </div>
                    </div>
                )}

            </Modal.Body>

            {!isSuccess && <Modal.Footer>

                <Button
                    variant="light"
                    onClick={closeModal}
                    className="cancel-btn"
                >
                    Cancel
                </Button>

                <Button
                    className="save-btn"
                    disabled={listStatus}
                    onClick={handleAction}
                >
                    {listStatus
                        ? (
                            <>
                                <i className="fa fa-spinner fa-spin me-2"></i>

                                {tabKey === "create"
                                    ? "Creating..."
                                    : "Updating..."
                                }
                            </>
                        )
                        : (
                            <>
                                <i
                                    className={`fa ${tabKey === "create"
                                        ? "fa-plus"
                                        : "fa-check"
                                        } me-2`}
                                />

                                {tabKey === "create"
                                    ? "Create List"
                                    : "Update List"
                                }
                            </>
                        )}
                </Button>

            </Modal.Footer>}
        </Modal>
    );
};

export default AddToListModal;
